import { api, convexClient } from '../lib/convex';
import { pushPermission, pushSupported, subscribePush } from '../lib/push';
import { rememberPushEndpoint, savedPushEndpoint } from './storage';

/**
 * With permission already granted: makes sure the browser has a subscription and that
 * every given device token (one per circle) has it saved. Never prompts.
 * Callers must not pass preview tokens (preview devices never get push).
 */
export async function syncPushSubscription(publicKey: string, deviceTokens: string[]): Promise<boolean> {
  if (pushPermission() !== 'granted' || deviceTokens.length === 0) return false;
  const sub = await subscribePush(publicKey);
  if (!sub.endpoint) return false;
  for (const deviceToken of deviceTokens) {
    if (savedPushEndpoint(deviceToken) === sub.endpoint) continue;
    await convexClient.mutation(api.devices.savePushSubscription, { deviceToken, subscription: sub });
    rememberPushEndpoint(deviceToken, sub.endpoint);
  }
  return true;
}

/** Asks for permission (call straight from a tap) and saves the subscription if granted. */
export async function requestPush(publicKey: string, deviceTokens: string[]): Promise<NotificationPermission | 'unsupported'> {
  if (!pushSupported()) return 'unsupported';
  const permission = await Notification.requestPermission();
  if (permission === 'granted') {
    try {
      await syncPushSubscription(publicKey, deviceTokens);
    } catch (err) {
      console.warn('Circles: push subscription failed', err);
    }
  }
  return permission;
}
